import { render, staticRenderFns } from "./FactoryDeliveryNotePreview.vue?vue&type=template&id=4b619561&scoped=true"
import script from "./FactoryDeliveryNotePreview.vue?vue&type=script&lang=ts"
export * from "./FactoryDeliveryNotePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b619561",
  null
  
)

export default component.exports